<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    :modelNameSingular="modelNameSingular"
    :formErrors="formErrors"
    ref="baseDelete"
  >
    <p> Você tem certeza que deseja deletar o grupo de tributação <b>{{entry.name}}</b>?</p>
  </BaseDelete>
</template>

<script>
import BaseDelete from "@shared_components/base_delete.vue";
import gql from 'graphql-tag';

export default {
  data () {
    return {
      error: null,
      loading: true,
      formErrors: []
    }
  },
  components: {
    BaseDelete: BaseDelete
  },
  props: {
    entry: Object,
    modelNameSingular: String,
  },
  methods: {
    destroyServerEntry: function(taxationGroup) {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: DESTROY_OUTBOUND_NFE_TAXATION_GROUP_MUTATION,
          variables: {
            id: taxationGroup.id
          }
        })
        .then(response => {
          // console.log(response.data)
          this.$emit("entry-destroyed");
          this.$refs.baseDelete.closeDialog();
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    destroyEntry: function() {
      this.destroyServerEntry(this.entry);
    },
  }
}

const DESTROY_OUTBOUND_NFE_TAXATION_GROUP_MUTATION = gql `
  mutation($id: ID!) {
    destroyTaxationGroup(id: $id) {
      taxationGroup{
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
